import $ from 'jquery';

const findAvailableById = (id, month, year) => {
    return $.ajax({
        // eslint-disable-next-line no-undef
        url: themeObj.ajaxUrl,
        method: 'POST',
        data: {
            // eslint-disable-next-line no-undef
            ...themeObj.get_product_not_available,
            id, month, year,
        }
    })
}

export default { findAvailableById }